// ============================================================================
// Help Content Registry
// Maps page keys (matching route segments) to their HelpContent objects.
// ============================================================================

import type { HelpContent } from './types';
import { dashboardHelp } from './dashboard';
import { settingsHubHelp } from './settings-hub';
import { settingsGeneralHelp } from './settings-general';
import { settingsProjectHelp } from './settings-project';
import { settingsUserPermissionsHelp } from './settings-user-permissions';
import { settingsIntegrationsHelp } from './settings-integrations';
import { settingsNotificationsHelp } from './settings-notifications';
import { settingsUserPreferencesHelp } from './settings-user-preferences';
import { settingsTemplatesHelp } from './settings-templates';
import { projectsHelp } from './projects';
import { projectDetailsHelp } from './project-details';
import { projectTemplatesHelp } from './project-templates';
import { resourceDirectoryHelp } from './resource-directory';
import { rolesRatesHelp } from './roles-rates';
import { skillsHelp } from './skills';
import { wipReportingHelp } from './wip-reporting';
import { projectStatusHelp } from './project-status';
import { budgetVarianceHelp } from './budget-variance';
import { projectPlHelp } from './project-pl';
import { projectForecastHelp } from './project-forecast';
import { profitabilityReportHelp } from './profitability-report';
import { utilisationHelp } from './utilisation';
import { auditLogHelp } from './audit-log';
import { projectTransactionsHelp } from './project-transactions';

export type HelpPageKey =
  | 'dashboard'
  | 'settings'
  | 'settings-general'
  | 'settings-project'
  | 'settings-user-permissions'
  | 'settings-integrations'
  | 'settings-notifications'
  | 'settings-user-preferences'
  | 'settings-templates'
  | 'projects'
  | 'project-details'
  | 'project-templates'
  | 'directory'
  | 'roles-rates'
  | 'skills'
  | 'project-transactions'
  | 'wip-reporting'
  | 'wip'
  | 'project-status'
  | 'budget-variance'
  | 'project-pl'
  | 'project-forecast'
  | 'profitability-report'
  | 'profitability'
  | 'utilisation'
  | 'audit-log';

const HELP_REGISTRY: Record<HelpPageKey, HelpContent> = {
  'dashboard':                  dashboardHelp,
  'settings':                   settingsHubHelp,
  'settings-general':           settingsGeneralHelp,
  'settings-project':           settingsProjectHelp,
  'settings-user-permissions':  settingsUserPermissionsHelp,
  'settings-integrations':      settingsIntegrationsHelp,
  'settings-notifications':     settingsNotificationsHelp,
  'settings-user-preferences':  settingsUserPreferencesHelp,
  'settings-templates':         settingsTemplatesHelp,
  'projects':                   projectsHelp,
  'project-details':            projectDetailsHelp,
  'project-templates':          projectTemplatesHelp,
  'directory':                  resourceDirectoryHelp,
  'roles-rates':                rolesRatesHelp,
  'skills':                     skillsHelp,
  'project-transactions':       projectTransactionsHelp,
  'wip-reporting':              wipReportingHelp,
  'wip':                        wipReportingHelp,
  'project-status':             projectStatusHelp,
  'budget-variance':            budgetVarianceHelp,
  'project-pl':                 projectPlHelp,
  'project-forecast':           projectForecastHelp,
  'profitability-report':       profitabilityReportHelp,
  'profitability':              profitabilityReportHelp,
  'utilisation':                utilisationHelp,
  'audit-log':                  auditLogHelp,
};

/**
 * Returns the HelpContent for the given page key, or undefined if no content
 * has been defined for that page yet.
 */
export function getHelpContent(key: string): HelpContent | undefined {
  return HELP_REGISTRY[key as HelpPageKey];
}

export type { HelpContent };
export * from './types';
